// src/features/security/SecurityWorkspacePage.tsx
import { useParams } from 'react-router-dom';

import { PageContainer } from '../../app/components/foundation';
import {
  SecurityWorkspaceHeader,
  SecurityPolicyCard,
  SecurityPermissionsCard,
  SecuritySessionsCard,
  SecurityTimelineCard,
} from './components';
import { useSecurityWorkspaceMock } from './hooks/useSecurityWorkspaceMock';
import './styles/security.css';

/**
 * Security Workspace Foundation (/security/:id). Same shell pattern
 * as ServiceWorkspacePage/CommissionWorkspacePage: PageContainer +
 * feature-owned header, card grid below, RTL/Persian throughout,
 * existing tokens/primitives only.
 *
 * Reads `id` from the route params and resolves everything through
 * useSecurityWorkspaceMock(id) — the module record plus its
 * policy/permissions/sessions/timeline, all still mock data from
 * data/security.mock.ts. No API calls; useSecurityWorkspaceMock is
 * the seam a later phase swaps for a real security-detail hook
 * without touching this file or the cards below it (same shape).
 */
export function SecurityWorkspacePage() {
  const { id } = useParams<{ id: string }>();
  const { module, policy, permissions, sessions, timeline } = useSecurityWorkspaceMock(id);

  if (!module) {
    return (
      <PageContainer className="flex flex-col gap-6">
        <p className="vania-security-workspace-empty">ماژول مورد نظر یافت نشد.</p>
      </PageContainer>
    );
  }

  return (
    <PageContainer className="flex flex-col gap-6">
      <SecurityWorkspaceHeader module={module} />

      <div className="vania-security-workspace-grid">
        <SecurityPolicyCard policy={policy} />
        <SecurityPermissionsCard permissions={permissions} />
        <SecuritySessionsCard sessions={sessions} />
        <SecurityTimelineCard timeline={timeline} />
      </div>
    </PageContainer>
  );
}
